import { Fragment, memo } from "react";
import UserPopover from "Components/TitleBar/UserPopover";
import "Components/TitleBar/TitleBar.less";
import { TitleBar as ClintonTitleBar, HoverIcon } from "@clintonelec/react-storybook";
import { noop } from "lodash";

const TitleBar = () => {
	const rightContent = (
		<Fragment>
			<a
				className="help-link"
				href="https://support.clintonelectronics.com"
				target="_blank"
				rel="noreferrer"
			>
				<ClintonTitleBar.Button>
					<HoverIcon name="circle-question" />
				</ClintonTitleBar.Button>
			</a>
			<div className="divider" />
			<UserPopover />
		</Fragment>
	);

	return (
		<ClintonTitleBar
			isCollapsible={ false }
			logoClassName="title-bar-logo"
			rightContent={ rightContent }
			toggleCollapsed={ noop }
		/>
	);
};

export default memo(TitleBar);
